import React, { PureComponent } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux'
import NeedHelp from '../Elements/NeedHelp';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import FacebookTab from './facebookTab';
import { GET_FLITER_ID, VALIDATE_URL, getInitialRoute, showAddAccountAlertNew, isAppleSafari, CalendlyPop, getFeedCount } from '../../../../../../utils'
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc'
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { HUBSPOT_URL } from '../../../../../../actions/api';

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Facebookfeed extends PureComponent {
    state = {
        filterType: 'Page',
        selectedFilterId:8,
        textField: "",
        account: null,
        albumUrl: '',
        errorMsg: 'This field is required',
        error: false,
        albumUrlError: false,
        album: { label: 'Single Album', value: '65' },
        connetedAccount: null,
        moderation:false,
        showPopup:false
    }

    componentDidMount() {
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onTextFieldChange = value => this.setState({ textField: value, error: false })
    onAlbumFieldChange = value => this.setState({ albumUrl: value, albumUrlError: false });

    onAccountChange = (value, parent) => {
        if (["Page Reviews", "Page Mentions"].includes(this.state.selectedFilterTab)) {
            if (value == 0) this.props.selectAccount(null)
            else this.props.selectAccount(value)
        }

        this.setState({ connetedAccount: parent })
        this.setState({ account: value });
    }
    onCheckHandler = event => { this.setState({ [event.target.name]: event.target.checked }) }
    onAlbumChange = value => this.setState({ album: value })
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })

    addFacebookAccount = () => {
        this.props.updateFeedPostBody(this.createFeedPostData());
        showAddAccountAlertNew({id:3,name:"facebook"},"addFeed",[62,55].includes(this.state.selectedFilterId));
    }


    createFeedPostData = () => {
        const { textField, album, connetedAccount, account, albumUrl, moderation,selectedFilterId } = this.state;
        const { wallId, networkId } = this.props;
        var obj = {
            wallId:wallId,
            networkId: networkId,
            filter: selectedFilterId == 67 ? parseInt(album.value) : selectedFilterId,
            connetedAccount: [62, 55].includes(selectedFilterId) ? connetedAccount : 0,
            account: [62, 55].includes(selectedFilterId) ? account : connetedAccount,
            field: selectedFilterId == 2 ? textField?.split('#').join('') : textField,
            onlyReels: 0,
            hashtagIGTV: 0,
            moderation: moderation ? 1 : 0,
        }
        if (selectedFilterId == 67) {
            obj['field'] = albumUrl;
        }
        if (![8, 67, 2].includes(selectedFilterId)) {
            obj['field'] = '';
        }

        return obj;
    }

    createFeed = (connectAccountId) => {
        const {hideAddfeed,navigation,wallId} = this.props;
        let obj = this.createFeedPostData();
        if(connectAccountId){
            obj = {...obj,account:connectAccountId};
        }
        this.setState({ loading: true, error: false, handleError: false, mentionError: false, advanceError: false, favoriteError: false, listNameError: false, showListError: false });
        createFeedAction(obj, 3, (feedId) => this.setState({ loading: false },()=>{
            if(feedId){
                hideAddfeed();
                navigation(`/moderation/index/${wallId}`);
            }
        }))
    }

    onSubmit = () => {
        const { textField, selectedFilterId, connetedAccount, albumUrl } = this.state;
        const { accountId } = this.props;
        if (!textField?.trim() && selectedFilterId == 2) {
            this.setState({ error: true, errorMsg: 'This field is required' })
        } else if ((!textField || textField == "") && selectedFilterId == 8) {
            this.setState({ error: true, errorMsg: 'This field is required' })
        } else if (selectedFilterId == 8 && !VALIDATE_URL(textField)) {
            this.setState({ error: true, errorMsg: 'Please enter valid Page Url' })
        } else if ((!albumUrl || albumUrl == "") && selectedFilterId == 67) {
            this.setState({ albumUrlError: true, errorMsg: 'This field is required' })
        } else if (selectedFilterId == 67 && !VALIDATE_URL(albumUrl)) {
            this.setState({ albumUrlError: true, errorMsg: 'Please enter valid Album Url' })
        } else {
            if ((connetedAccount && accountId )|| selectedFilterId == 2) {
                this.createFeed();
            } else {
                this.addFacebookAccount();
            }
        }
    }

    needSupportLinks = (filterType) => {
        if(getInitialRoute() === 'widget'){
            switch (filterType) {
                case 'Page':
                    return ['https://vimeo.com/514242590/108689d25e', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
                case 'My Profile Posts':
                    return ['https://vimeo.com/514561656/1062dd4042', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
                case 'Albums':
                    return ['https://vimeo.com/514573998/6002c702b9', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
                case 'Page Reviews':
                    return ['https://vimeo.com/514597045/de6b2ffa06', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
                case 'Page Mentions':
                    return ['https://player.vimeo.com/video/497245578', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
                default:
                    return ['https://vimeo.com/514242590/108689d25e', 'https://taggbox.com/support/add-facebook-feed-using-taggbox-widget/']
            }
        }else{
            switch (filterType) {
                case 'Page':
                    return ['https://vimeo.com/537133757/7a15a7ca9a', '']
                case 'My Profile Posts':
                    return ['https://vimeo.com/539148809/df0215b0e4', '']
                case 'Albums':
                    return ['https://vimeo.com/540121650/74309b9335', '']
                case 'Page Reviews':
                    return ['https://vimeo.com/540123334/120d89e423', '']
                case 'Page Mentions':
                    return ['https://vimeo.com/537133757/7a15a7ca9a', '']
                default:
                    return ['https://vimeo.com/537133757/7a15a7ca9a', '']
            }
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId,type} = response;
        const { selectedFilterId } = this.state;
        if(type == "addFeed"){
            addUserAccount(networkId, data, [55, 62].includes(selectedFilterId) ? (responseData) => this.props.updateConnectedAccountList(responseData) : (connectAccountId) => this.createFeed(connectAccountId),localStorage.getItem('ownerId'), selectedFilterId);
        }

    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { feedInfo,connectedAcc, onBack, onFilterNameChange, userData, feeds, networkId } = this.props;
        const { textField, account, album, moderation, filterType,albumUrlError, errorMsg, connetedAccount, error, loading,selectedFilterId} = this.state
        const fbHashtagCount = getFeedCount(networkId, selectedFilterId, feeds)
        const fbHashtag = filterType =='hashtag' && (userData?.UserRule?.facebookhashtag != 1 || !(fbHashtagCount < userData?.UserRule?.facebookHashtagLimit))
        return (
            <><div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className={`tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup ${fbHashtag ? 'faceBookHashtag':''}`}>
                            <Tabs defaultActiveKey="Page" value={filterType} id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-5" onSelect={e => this.setState({ filterType: e, selectedFilterId: GET_FLITER_ID(e, feedInfo), textField:"", errorMsg:""}, () => onFilterNameChange(e))}>
                                {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter =>
                                    <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link className= p-0" title={<span>{filter.feedName}</span>}>
                                        <FacebookTab
                                            onAddAccount={this.addFacebookAccount}
                                            connetedAccount={connetedAccount}
                                            onConnectedAccountChange={this.onConnectedAccountChange}
                                            onAlbumFieldChange={this.onAlbumFieldChange}
                                            tab={filter.feedtype}
                                            text={textField}
                                            error={error}
                                            errorMsg={errorMsg}
                                            albumUrlError={albumUrlError}
                                            filterType={filterType}
                                            connectedAcc={connectedAcc}
                                            onTextChange={this.onTextFieldChange}
                                            account={account}
                                            onAccountChange={this.onAccountChange}
                                            onCheckHandler={this.onCheckHandler}
                                            onAlbumChange={this.onAlbumChange}
                                            album={album}
                                            moderation={moderation} />
                                    </Tab>
                                ) : null}
                            </Tabs>
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4 asdfasdasdf">
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                    <SubmitFeedRequest onBack={onBack} onSubmit={this.onSubmit} loading={loading}/>
                                </div>
                            </div>
                            {fbHashtag ? <div className="text-center w-100 py-10"> <h5>Multiply Engagement with a live Facebook Hashtag Wall.</h5>  <p>For more insights into this feature, connect with our Sales team.</p> <p><a href="javascript:void(0)" className="btn btn-primary px-8 py-3" onClick={()=>this.setState({showPopup:true})}> Book A Demo</a> </p></div> :''}
                            <CalendlyPop show={this.state.showPopup} hidePop={()=>this.setState({showPopup:false})} url={HUBSPOT_URL} />
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc,
        userData: state.authenticated.userData,
        feeds: state.manageFeeds.feeds
    }
}

export default connect(mapStateToProps)(Facebookfeed)